import { SignInPasswordlessConfirmationBase } from '@/app_components/SignIn/Confirmations/SignInPasswordlessConfirmationBase';
import type { SignInFlow } from '@/app_lib/types/accounts/signInFlow.entities';

interface PasswordlessConfirmationProps {
  email: string;
  redirectCookieKey: string;
  flow: SignInFlow;
}

export const SignInPasswordlessConfirmation = ({ email, flow, redirectCookieKey }: PasswordlessConfirmationProps) => {
  const headerText = 'Check your email to continue';
  const subheaderText = `A sign-in link is on its way to ${email}. Click it to finish signing in.`;

  return (
    <SignInPasswordlessConfirmationBase
      flow={flow}
      headerText={headerText}
      redirectCookieKey={redirectCookieKey}
      resendEmail={email}
      subheaderText={subheaderText}
    />
  );
};
